<template>
    <div class="stars-box">
        <div class="stars-hig-box">
            <div class="stars-hig">
                <img v-for="index in 5" :key="index" v-if="numScore > index" class="stars-img"
                :src="require('@/assets/images/project/stare-1.png') "/>
            </div>
        </div>
        <div class="stars-ash-box">
            <div class="stars-ash">
                <img v-for="index in 5" :key="index" v-if="numScore + 1 > index" class="stars-img"
                :src="stares(numScore) == 2 ? require('@/assets/images/project/xing-ban.png') : require('@/assets/images/project/stare-1.png') "/>
            </div>
        </div>
        <div class="stars-ash-box-item">
            <div class="stars-ash">
                <img v-for="index in 5" :key="index" class="stars-img"
                :src="require('@/assets/images/project/hui-stare.png') "/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'stares',
        props: {
            numScore: {
                type: Number,
                defatule: '',
            },
        },
        methods:{
            stares(num){
                if(num.toFixed(2).split('.')[1] == '00'){
                    num = 1
                }else{
                    if(Number(num.toFixed(2).split('.')[1] <= 60)){
                        num = 2
                    }else{
                        num = 3
                    }
                }
                return num
            }
        }
    }
</script>

<style scoped lang="scss">
    .stars-box{
        width: 230px;
        position: relative;
        .stars-hig-box{
            position: absolute;
            display: flex;
            z-index: 6;
            .stars-hig{
                position: relative;
                .stars-img{
                    margin-right: 12px;
                    width: 32px;
                    height: 32px;
                }
                .stars-img-item{
                    position: absolute;
                    margin-right: 12px;
                    width: 32px;
                    height: 32px;
                    clip:rect(0px , var(--percen) , 32px , 0px);
                    // clip:rect(0px , 19px , 32px , 0px);
                }
            }
        }
        .stars-ash-box{
            position: absolute;
            display: flex;
            z-index: 4;
            .stars-ash{
                img{
                    margin-right: 12px;
                    width: 32px;
                    height: 32px;
                }
            }
        }
        .stars-ash-box-item{
            position: absolute;
            display: flex;
            z-index: 2;
            .stars-ash{
                img{
                    margin-right: 12px;
                    width: 32px;
                    height: 32px;
                }
            }
        }
    }
</style>
